/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/hanger'
export default icon
